import { defineStore } from 'pinia'
import { persistConfig } from '../index'

/**
 * App Store
 * 管理应用的基础配置和全局状态
 */
export const useAppStore = defineStore('app', {
  state: () => ({
    // 应用名称
    appName: import.meta.env.VITE_APP_NAME || 'Electron Vue Vite App',
    
    // 应用版本
    appVersion: import.meta.env.VITE_APP_VERSION || '0.0.1',
    
    // 环境类型
    environment: import.meta.env.MODE || 'development',
    
    // API基础URL
    apiBaseUrl: import.meta.env.VITE_API_BASE_URL || '/api',
    
    // 是否是首次加载
    isFirstLoad: true,
    
    // 加载状态
    loading: false,
    
    // 全局错误信息
    error: null,
    
    // 最后一次活动时间
    lastActivityTime: Date.now(),
    
    // 窗口尺寸信息
    windowSize: {
      width: window.innerWidth,
      height: window.innerHeight
    }
  }),
  
  getters: {
    // 是否是开发环境
    isDevelopment: (state) => state.environment === 'development',
    
    // 是否是生产环境
    isProduction: (state) => state.environment === 'production',
    
    // 获取格式化的版本号
    formattedVersion: (state) => {
      return `v${state.appVersion}`
    },
    
    // 是否在小屏幕上
    isSmallScreen: (state) => {
      return state.windowSize.width < 768
    }
  },
  
  actions: {
    // 设置加载状态
    setLoading(loading) {
      this.loading = loading
    },
    
    // 设置错误信息
    setError(error) {
      this.error = error
    },
    
    // 清除错误信息
    clearError() {
      this.error = null
    },
    
    // 更新窗口尺寸
    updateWindowSize(width, height) {
      this.windowSize = {
        width: width || window.innerWidth,
        height: height || window.innerHeight
      }
    },
    
    // 更新最后活动时间
    updateLastActivityTime() {
      this.lastActivityTime = Date.now()
    },
    
    // 设置首次加载状态
    setFirstLoad(isFirstLoad) {
      this.isFirstLoad = isFirstLoad
    },
    
    // 初始化应用状态
    async initialize() {
      try {
        this.setLoading(true)
        
        // 注册窗口尺寸变化监听
        const handleResize = () => {
          this.updateWindowSize()
        }
        
        window.addEventListener('resize', handleResize)
        
        // 注册活动监听
        const handleActivity = () => {
          this.updateLastActivityTime()
        }
        
        window.addEventListener('mousemove', handleActivity)
        window.addEventListener('keydown', handleActivity)
        
        // 标记为非首次加载
        this.setFirstLoad(false)
        
      } catch (error) {
        console.error('Failed to initialize app state:', error)
        this.setError(error)
      } finally {
        this.setLoading(false)
      }
    }
  },
  
  // 配置持久化
  persist: persistConfig.createPersistConfig('app', {
    // 只持久化必要的配置
    paths: ['appName', 'appVersion', 'environment', 'apiBaseUrl']
  })
})